module.exports = __webpack_public_path__ + "static/media/028.1ed02186.png";